/**
 * Initialize Google Tag Manager
 *
 * This loads GTM after Datadog initializes to prevent Datadog's XHR patching
 * from adding x-datadog-origin headers to third-party tracking requests
 * (specifically Contentsquare, which is loaded via GTM).
 *
 * Note: window.dataLayer is initialized in index.html to queue events before
 * GTM loads, ensuring no tracking data is lost.
 */

// NODE_ENV gates "should GTM load at all" — false in local dev/test, true in
// deployed builds. APP_ENV is not used here because GTM should load in all
// deployed environments regardless of which backend they target.
if (process.env.NODE_ENV === 'production') {
  // Determine GTM container ID based on environment
  let gacct
  switch (window.location.host) {
    case 'app.sidecarhealth.com':
      gacct = 'GTM-M3C8XWS'
      break
    case 'staging-app.sidecarhealth.com':
      gacct = 'GTM-PSD22F3'
      break
    case 'qa-app.sidecarhealth.com':
      gacct = 'GTM-WHKXVQZ'
      break
    case 'dev-app.sidecarhealth.com':
    case 'localhost':
    default:
      gacct = 'GTM-K7PT24K'
      break
  }

  // Push GTM start event to dataLayer (already initialized in HTML)
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  })

  // Inject GTM script
  const script = document.createElement('script')
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gacct}`
  script.async = true

  const firstScript = document.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore(script, firstScript)
}
